import React, { Component } from 'react';
import './Welcome.scss';

class welcome extends Component {
  render() {
    return (
      <div>
        {/* <div className="ImageContainer">
          <img src={Immagine} className="img" alt="" />
        </div>
        <div className="container">
          <a className="a" href="https://unsplash.com/@brucemars?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge"
            target="_blank"
            rel="noopener noreferrer"
            title="Download free do whatever you want high-resolution photos from bruce mars">
            <span className="span">
              <svg className="swg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <title>unsplash-logo</title>
                <path d="M10 9V0h12v9H10zm12 5h10v18H0V14h10v9h12v-9z"></path>
              </svg>
            </span>
            <span >Photo by bruce mars on Unsplash</span>
          </a>
        </div> */}
      </div>
    );
  }
}
export default welcome;